<template>
  <v-app footer style="background-color:White;">
    <v-app-bar flat app dense>{{title}}</v-app-bar>
    <v-content>
      <router-view id="view-router" ref="view-router" :key="$route.fullPath" scrollable></router-view>
    </v-content>
  </v-app>
</template>

<script>



export default {

  mounted ()
  {
    this.title = this.$root.$data.$env.VUE_APP_APP_TITLE;
  },

  name: "App",
  data: () =>  {
    return {
      title: "",
    }
  }
}
</script>